import { AppDispatch } from "..";
import { podActions } from "../slices/PODSlice";
import {
  fetchPOD,
  fetchPODDisclaimers,
  fetchPODInfoQuestions,
} from "../../services/pods";
import InfoQuestion from "../../ts/models/InfoQuestion";

export const getPODData = (id: string) => {
  return async (dispatch: AppDispatch) => {
    fetchPOD(id)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data) {
            dispatch(podActions.getPOD(data));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getPODDisclaimers = (ids: string[]) => {
  return async (dispatch: AppDispatch) => {
    fetchPODDisclaimers(ids)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          dispatch(podActions.getPODDisclaimers(data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getPODInfoQuestions = (ids: string[]) => {
  return async (dispatch: AppDispatch) => {
    fetchPODInfoQuestions(ids)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          let infoQuestionData: any[] = [];
          let infoQuestionMap = new Map<string, InfoQuestion>();
          data.forEach((infoQuestion: InfoQuestion) => {
            infoQuestionMap.set(infoQuestion.id, infoQuestion);
          });
          infoQuestionData = ids.map((questionId) =>
            infoQuestionMap.get(questionId)
          );
          dispatch(podActions.getPODInfoQuestions(infoQuestionData));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getProductInfoQuestions = (ids: string[]) => {
  return async (dispatch: AppDispatch) => {
    fetchPODInfoQuestions(ids)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          let infoQuestionData: any[] = [];
          let infoQuestionMap = new Map<string, InfoQuestion>();
          data.forEach((infoQuestion: InfoQuestion) => {
            infoQuestionMap.set(infoQuestion.id, infoQuestion);
          });
          infoQuestionData = ids.map((questionId) =>
            infoQuestionMap.get(questionId)
          );
          dispatch(podActions.getProductInfoQuestions(infoQuestionData));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
